export const load = () => ({
	h1: 'Media List',
	showTitle: true,
});
